<template>
  <fts-modal
    class="designer-modal fts-console-validator"
    headerClass="designer-header"
    contentClass="designer-body"
    :footer="false"
    @close="close"
    v-if="show">

    <template #header>
      <div class="designer-header-wrapper">
        <div class="designer-header-title">Oops! Configuration incomplete.</div>
      </div>
      
      <div class="designer-header-actions">
        <fts-btn text icon @click="close" class="designer-header-action">
          <font-awesome-icon :icon="['fas', 'times']"/>
        </fts-btn>
      </div>
    </template>

    <template #body>
      <div style="margin-bottom: 1rem" v-for="x in validator" :key="x.name">
        <template v-if="x.name === 'Information'">
          <div class="validator-title">Information</div>
          <!-- every required -->
          <div class="err-msg" v-if="x.list.some(y => !y.displayName.required)">Please ensure all Display Name are filled.</div>
          <!-- each -->
          <template v-for="y in x.list">
            <div class="element-wrapper" v-if="y.displayName.required" :key="y.$model.id">          
              <div class="element-info">
                <i class="element-icon" :class="informationIcon(y.$model.type)" /> 
                <div class="element-name">{{y.$model.displayName}}</div>
              </div>
              <div class="err-msg" v-if="y.displayName && !y.displayName.unique">{{y.$model.displayName}} is already being used.</div>
              <div class="err-msg" v-if="y.displayName && !y.displayName.format">Oops! you cannot use these symbols {{informationFormatRestriction}}.</div>
              <div class="err-msg" v-if="y.displayName && !y.displayName.nonReserved">Oops! you cannot use reserved words: {{informationReservedKeywords}}.</div>
              <div class="err-msg" v-if="y.fieldName && !y.fieldName.required">Information field name for {{y.$model.displayName}} is required.</div>
              <div class="err-msg" v-if="y.type && !y.type.required">Information type for {{y.$model.displayName}} is required.</div>
              <div class="err-msg" v-if="y.connectionId && !y.connectionId.required">Module for {{y.$model.displayName}} is required.</div>
              <div class="err-msg" v-if="y.connectionField && !y.connectionField.required">Display information for {{y.$model.displayName}} is required.</div>

              <template v-if="y.fields.$invalid">
                <!-- every columns required -->
                <div class="err-msg" v-if="y.fields.list.some(col => !col.displayName.required)">Plase ensure all Display Name are filled.</div> 
                <div class="err-msg" v-if="!y.fields.required">At least must have a column for {{y.$model.displayName}}.</div>
                <!-- each -->
                <template v-for="col in y.fields.list" >
                  <div class="element-wrapper columns" v-if="col.displayName.required" :key="col.$model.id">
                    <div class="element-info">
                      <i class="element-icon" :class="informationIcon(col.$model.type)" /> 
                      <div class="element-name">{{col.$model.displayName}}</div>
                    </div>
                    <div class="err-msg" v-if="col.displayName && !col.displayName.unique">{{col.$model.displayName}} is already being used.</div>
                    <div class="err-msg" v-if="col.displayName && !col.displayName.format">Oops! you cannot use these symbols {{informationFormatRestriction}}.</div>
                    <div class="err-msg" v-if="col.displayName && !col.displayName.nonReserved">Oops! you cannot use reserved words: {{informationReservedKeywords}}.</div>
                    <div class="err-msg" v-if="col.fieldName && !col.fieldName.required">Information field name for {{col.$model.displayName}} is required.</div>
                    <div class="err-msg" v-if="col.type && !col.type.required">Information type for {{col.$model.displayName}} is required.</div>
                    <div class="err-msg" v-if="col.connectionId && !col.connectionId.required">Module for {{col.$model.displayName}} is required.</div>
                    <div class="err-msg" v-if="col.connectionField && !col.connectionField.required">Display information for {{col.$model.displayName}} is required.</div>
                  </div>
                </template>
              </template>
            </div>
          </template>
        </template>

        <template v-if="x.name === 'Activity'">
          <div class="validator-title">Activity</div>
          <!-- every required -->
          <div class="err-msg" v-if="x.list.some(y => !y.name.required)">Please ensure all Activity Name are filled.</div>
          <!-- each -->
          <template v-for="y in x.list">
            <div class="element-wrapper" v-if="y.name.required" :key="y.$model.id">
              <div class="element-info">
                <fts-moji
                  :emoji="y.$model.emoji"
                  :size="16"
                  class="module-icon"
                  v-if="y.$model.emoji"
                />
                <div class="element-name">{{y.$model.name}}</div>
              </div>
              <div class="err-msg" v-if="!y.name.unique">{{y.$model.name}} is already being used.</div>
              <div class="err-msg" v-if="!y.name.nonReserved">
                Oops! you cannot use reserved words: {{activityReservedKeywords}}.
              </div>
            </div>
          </template>
        </template>

        <template v-if="x.name === 'State'">
          <div class="validator-title">State</div>
          <!-- every required -->
          <div class="err-msg" v-if="x.list.some(y => !y.name.required)">Please ensure all State Name are filled.</div>
          <!-- each -->
          <template v-for="y in x.list">
            <div class="element-wrapper" v-if="y.name.required" :key="y.$model.id">
              <fts-state
                :state="{
                  id: y.$model.id, 
                  name: y.$model.name,
                  color: y.$model.color 
                }" />
              <div class="err-msg" v-if="x.list.some(y => !y.name.unique)">{{y.$model.name}} is already being used.</div>
            </div>
          </template>
        </template>

        <template v-if="x.name === 'Flow'">
          <div class="validator-title">Flow</div>
          <!-- from state, activity required -->
          <div class="err-msg" v-if="x.list.some(y => !y.fromStateId.required || !y.activityId.required)">
            From State and Activity, either one is required.
          </div>
          <!-- conditional states at least contain 1 to state -->
          <div class="err-msg" v-if="x.list.some(y => !y.conditionalStates.required)">
            Conditional States must contain one or more than one To State.
          </div>
          <!-- every to state unique -->
          <div class="err-msg" v-if="x.list.some(y => y.conditionalStates.everyUnique === false)">
            Please ensure all To State must be unique.
          </div>
          <!-- every to state required -->
          <div class="err-msg" v-if="x.list.some(y => y.conditionalStates.everyToStateRequired === false)">
            Please ensure all To State is filled.
          </div>
        </template>

      </div>
    </template>

  </fts-modal>
</template>

<script>
import commons from "../commons/commons";
import validator from "../commons/designValidator";

import FTSModal from "../elements/FTSModal";
import FTSState from "../elements/FTSState";
import FTSBtn from "../elements/FTSBtn";
import FTSMoji from "../elements/FTSMoji";

const reducer = (res, val, ind, arr) => ind ? ind === arr.length - 1 ? `${res}, and ${val}` : `${res}, ${val}` : val

export default {
  components: {
    "fts-modal": FTSModal,
    "fts-state": FTSState,
    "fts-btn": FTSBtn,
    "fts-moji": FTSMoji
  },
  data: () => ({
    show: false
  }),
  methods: {
    informationIcon(type) {
      return commons.informationIcon(type);
    },
    open() {
      this.show = true
    },
    close() {
      this.show = false
    }
  },
  computed: {
    informationFormatRestriction() {
      return (
        Array.isArray(validator.informationFormatRestriction) ? validator.informationFormatRestriction : []
      ).reduce(reducer, null)
    },
    informationReservedKeywords() {
      return (
        Array.isArray(validator.informationReservedKeywords) ? validator.informationReservedKeywords : []
      ).reduce(reducer, null)
    },  
    activityReservedKeywords() {
      return (
        Array.isArray(validator.activityReservedKeywords) ? validator.activityReservedKeywords : []
      ).reduce(reducer, null)
    }
  },
  mounted() {
    window.eventBus.$on("consoleValidator", payload => {
      this.validator = []
      let res = lodash.cloneDeep(payload.validations)
      const type = payload.type || 'all'

      if (res.information && res.information.$invalid && type === 'all' || type === 'information') {
        let list = Object.values(res.information.$each.$iter).filter(x => x.$invalid)
        list.forEach(x => {
          if (x.$model.type === 14 && x.fields.$invalid) {
            const columnsList = Object.values(x.fields.$each.$iter).filter(y => y.$invalid)    
            if (list.length)
              x.fields.list = columnsList
          }
        })
        
        this.validator.push({
          name: 'Information',
          list: list
        })
      }

      if (res.activities && res.activities.$invalid && type === 'all' || type === 'activity') {
        this.validator.push({
          name: 'Activity',
          list: Object.values(res.activities.$each.$iter).filter(x => x.$invalid)
        })
      }

      if (res.states && res.states.$invalid && type === 'all' || type === 'state') {
        this.validator.push({
          name: 'State',
          list: Object.values(res.states.$each.$iter).filter(x => x.$invalid)
        })
      }

      if (res.flows && res.flows.$invalid && type === 'all' || type === 'flow') {
        let list = Object.values(res.flows.$each.$iter).filter(x => x.$invalid)
        list.forEach(x => {
          if (x.conditionalStates.$invalid) {
            const conditionalStatesList = Object.values(x.conditionalStates.$each.$iter).filter(y => y.$invalid)       
            if (conditionalStatesList.length) {
              x.conditionalStates.everyToStateRequired = conditionalStatesList.every(y => y.toStateId.required)
              x.conditionalStates.everyUnique = conditionalStatesList.every(y => y.unique)
            }
          }
        })

        this.validator.push({
          name: 'Flow',
          list: list
        })
      }

      this.open()
    });
  },
  beforeDestroy() {
    window.eventBus.$off("consoleValidator");
  }
}
</script>

<style lang="scss">
@import "../../assets/scss/vars.scss";

.fts-console-validator {
  .validator-title {
    margin-bottom: .375rem;
    font-weight: 500;
    font-size: 1.25rem;
  }

  .element-wrapper {
    padding-top: .375rem;
    padding-bottom: .375rem;
    &.columns {
      padding-left: 1.375rem;
    }
    .element-info {
      display: flex;
      align-items: center;
      .element-icon {
        margin-right: .575rem;
        font-size: 1rem;
        color: $secondaryColor;
      }
      .module-icon {
        margin-right: .575rem;
      }
      .element-name {
        font-size: 1rem;
      }
    }  
  }
  
  .element-info + .err-msg,
  .fts-state + .err-msg,
  .err-msg + .err-msg {
    padding-top: .175rem;
  }

  .err-msg {
    font-size: .875rem;
    color: $dangerColor;
  }
}

</style>